import React from "react"
import {RoomLabel} from "./RoomLabel"
import {RoomSize} from "./RoomSize"

export const RoomName = () => {
    return `${RoomLabel()}, ${RoomSize()}`
}